module.exports = __webpack_public_path__ + "img/CapeTip201505.a0fe4818.png";